/** Role-management service (T053/T055, US7). Wraps the admin-only assignRole callable. */
import { callable } from './firebase';
import type { Role } from '../types/entities';

export const assignRole = callable<
  { uid?: string; email?: string; role: Role | null },
  { uid: string; email: string; role: Role | null }
>('assignRole');
